import chowdeck from '../assets/platforms/chowdeck.png';
import glovo from '../assets/platforms/glovo.png';
import heyfood from '../assets/platforms/heyfood.png';
import nova from '../assets/platforms/nova.png';

const LOGOS: Record<string, string> = { chowdeck, glovo, heyfood, nova, nova_logistics: nova };

/**
 * A connected platform (chowdeck/glovo/heyfood/nova_logistics). Prefers the backend's own
 * `logoUrl` (apps/api returns one when a platform row has `logo_key` set) and falls back to the
 * bundled mark keyed by id/name so cards still look right before any admin uploads a custom logo.
 */
export function PlatformLogo({ platform, url, size = 28 }: { platform: string; url?: string | null; size?: number }) {
  const src = url ?? LOGOS[platform?.toLowerCase().replace(/\s+/g, '_')];
  if (!src) return <div style={{ width: size, height: size, borderRadius: size * 0.28, background: 'var(--surface-muted)' }} />;
  return (
    <img
      src={src}
      alt=""
      style={{ width: size, height: size, borderRadius: size * 0.28, objectFit: 'cover', background: '#fff', border: '1px solid var(--border)' }}
    />
  );
}
